import { hasRecentGps, isOnTheWay, isStationaryPerLiveBadge, Member } from "../types/member";
import { COLOR_IDLING, COLOR_MOVING } from "../constants/colors";
import { getMemberLiveBadge } from "../states/memberLiveBadgeState";

export function getMovingColor(member: Member) {
    return hasRecentGps(member) ? COLOR_MOVING : COLOR_IDLING;
}

// on-the-way with the position-based live badge taken into account: a member the
// server sees pausing / at a place is never on the way, whatever the gps speed says
export function isEffectivelyOnTheWay(member: Member) {
    return isOnTheWay(member) && !isStationaryPerLiveBadge(getMemberLiveBadge(member.uid));
}

export const sortMembers = (m1: Member, m2: Member) => (m1.name || m1.username) && (m2.name || m2.username)
    ? (m1.name || m1.username).localeCompare(m2.name || m2.username)
    : 0;
